import React, { forwardRef } from 'react';

import * as styles from 'src/components/molecules/AddressSearch/styles/styles';

export interface ResultProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLLIElement>, HTMLLIElement> {
  isContainer?: boolean;
  isHighlighted?: boolean;
  isResult?: boolean;
}

export const Result = forwardRef<HTMLLIElement, ResultProps>(
  (
    { isContainer = false, isHighlighted = false, isResult = true, ...props }: ResultProps,
    forwardedRef,
  ) => (
    <li
      css={styles.result}
      {...props}
      data-is-result={isResult}
      data-is-result-container={isContainer}
      data-is-result-highlighted={isHighlighted}
      ref={forwardedRef}
    >
      {props.children}
    </li>
  ),
);
